<p>price-management works!</p>
